var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{ref:"chart1",staticStyle:{"width":"100%","height":"700px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }